<template lang="pug">
  shListData(title="Conveyors History" resolver="conveyorsHistory" keyData="_id" component="shConveyor" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'ConveyorsHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/conveyor/ConveyorsHistory.vue